import { apiClient } from '../apiClient';
import {
  PolicyDto,
  CreatePolicyDto,
  UpdatePolicyDto,
} from '@shared/contracts';

export const policiesApi = {
  list: (): Promise<PolicyDto[]> => {
    return apiClient.get<PolicyDto[]>('/policies');
  },

  getById: (id: string): Promise<PolicyDto> => {
    return apiClient.get<PolicyDto>(`/policies/${id}`);
  },

  create: (payload: CreatePolicyDto): Promise<PolicyDto> => {
    return apiClient.post<PolicyDto>('/policies', payload);
  },

  update: (id: string, payload: UpdatePolicyDto): Promise<PolicyDto> => {
    return apiClient.put<PolicyDto>(`/policies/${id}`, payload);
  },
};
